import auth from "./auth";
import api from "./api";

const POINTS_SERVICE_URL = "points-service/";
const TIERING_SERVICE_URL = "tiering-service/";

export default {
    getPointsMechanicsList() {
        return new Promise((resolve, reject) => {
            api.get(`${POINTS_SERVICE_URL}mechanics/list`, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getTierList(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${TIERING_SERVICE_URL}v2/cms/tier/list`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getTier(id) {
        return new Promise((resolve, reject) => {
            api.get(
                `${TIERING_SERVICE_URL}v1/cms/tier/view/${id}`,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    createTier(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${TIERING_SERVICE_URL}v1/cms/tier/create`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateTier(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${TIERING_SERVICE_URL}v1/cms/tier/update/${payload.uuid}`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    deleteTier(id) {
        return new Promise((resolve, reject) => {
            api.post(
                `${TIERING_SERVICE_URL}v1/cms/tier/delete/${id}`,
                {},
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getMemberListByTier({ page, payload }) {
        return new Promise((resolve, reject) => {
            api.post(
                `${TIERING_SERVICE_URL}v1/cms/tier/member/list/${page}`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    publishTier({ id, payload }) {
        return new Promise((resolve, reject) => {
            api.post(
                `${TIERING_SERVICE_URL}v1/cms/tier/publish/${id}`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    moveMemberTier(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${TIERING_SERVICE_URL}v1/cms/tier/customer/move`,
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
};
